import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_HOVER_LINK_LIGHT_BLUE,
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	DESKTOP_SM_BP,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	padding: 60px 0;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding-top: 50px;
	padding-bottom: 50px;

	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 35px 30px;
		${(props) => (props.showInTabletAndMobile ? "" : "display: none;")}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
	}
`;
export const Header = styled.h2`
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 1;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;

	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 26px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1.31;
		max-width: 512px;
		margin: auto;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1.38;
	}
`;
export const Description = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	line-height: 1.69;
	text-align: center;
	max-width: 860px;
	margin-top: 25px;
	p {
		margin: 0px;
	}
	a {
		color: ${COLOR_HOVER_LINK_LIGHT_BLUE};
	}
	a:visited {
		text-decoration: none;
	}
`;
export const SubHeader = styled.div`
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${TABLET_BP}px) {
		text-align: left;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		text-align: center;
		font-size: 18px;
	}
`;
export const DetailsWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	align-items: center;
	margin-top: 50px;
	flex-direction: ${(props) => props.imagePosition === "left" && "row-reverse"};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-direction: column;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: 0px;
	}
`;
export const BulletPoints = styled.div`
	max-width: 500px;
	margin: ${(props) =>
		props.imagePosition === "left" ? "0 0 0 100px" : "0 100px 0 0px"};

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP -
		1}px) {
		max-width: 400px;
		margin: ${(props) =>
			props.imagePosition === "left" ? "0 0 0 30px" : "0 30px 0 0"};
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		max-width: 100%;
		text-align: center;
		margin: 20px 0;
	}
`;
export const TextPoint = styled.p`
	font-size: 16px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.69;
`;
export const PointsWrapper = styled.div`
	margin-top: 26px;
`;

export const ImageWrapper = styled.div`
	img {
		width: 500px;
	}

	@media only screen and (max-width: 1024px) and (min-width: 767px) {
		img {
			width: 400px;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		img {
			width: 100%;
		}
		margin: 0;
	}
`;

export const CtaContainer = styled.div`
	margin: 20px auto 0px auto;
`;
